import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

type Tone = 'success' | 'warning' | 'destructive'

interface OrderPillProps {
    children: string
    style?: StyleProp<ViewStyle>
    tone?: Tone
}

const OrderPill: FC<OrderPillProps> = ({ children, tone = 'success', style }) => {
    const { styles } = useStyles(stylesheet, { tone })

    return (
        <View style={[styles.container, style]}>
            <Typography.Description size="small" font="bold" style={styles.text}>
                {children}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        justifyContent: 'center',
        borderRadius: 4,
        maxWidth: '100%',
        paddingHorizontal: 4,
        paddingVertical: 3,
        variants: {
            tone: {
                success: {
                    backgroundColor: ColorEnum.EMERALD_700,
                },
                warning: {
                    backgroundColor: ColorEnum.YELLOW_600,
                },
                destructive: {
                    backgroundColor: ColorEnum.BRICK_500,
                },
            },
        },
    },
    text: {
        color: ColorEnum.WHITE,
    },
})

export default OrderPill
